import React from "react";
import { Spin } from "antd";
import { CustomIcons } from "../../assets";
import Colors from "../../config/Colors";
import * as S from "./styles";

interface SummaryCardsProps {
  totalAmountMade: number;
  totalCompanies: number;
  isLoadingOverview: boolean;
}

const SummaryCards: React.FC<SummaryCardsProps> = ({
  totalAmountMade,
  totalCompanies,
  isLoadingOverview,
}) => {
  return (
    <S.SummaryCardsContainer>
      <S.SummaryCard>
        <S.CardHeader>
          <S.CardTitle style={{ width: "226px" }}>
            Total Amount made{" "}
          </S.CardTitle>
          <S.CardIconContainer backgroundColor="#e6fdc7">
            <CustomIcons.CashIcon
              width={16}
              height={16}
              viewBox={null}
              svgColor="#2E6A07"
            />
          </S.CardIconContainer>
        </S.CardHeader>
        <S.CardContent>
          {isLoadingOverview ? (
            <Spin />
          ) : (
            <>
              <S.CardValue>
                {totalAmountMade > 0
                  ? `R${totalAmountMade.toLocaleString("en-ZA", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                    })}`
                  : "R0.00"}
              </S.CardValue>
              <S.CardDescription>
                Amount made via subscriptions{" "}
              </S.CardDescription>
            </>
          )}
        </S.CardContent>
      </S.SummaryCard>

      <S.SummaryCard>
        <S.CardHeader>
          <S.CardTitle style={{ width: "343px" }}>Total Companies</S.CardTitle>
          <S.CardIconContainer backgroundColor="#e2edfb">
            <CustomIcons.CompaniesIcon
              width={14}
              height={14}
              viewBox={null}
              svgColor={Colors.appMainColor}
            />
          </S.CardIconContainer>
        </S.CardHeader>
        <S.CardContent>
          {isLoadingOverview ? (
            <Spin />
          ) : (
            <>
              <S.CardValue>{totalCompanies.toLocaleString()}</S.CardValue>
              <S.CardDescription>
                The total number of companies currently registered in the
                system.
              </S.CardDescription>
            </>
          )}
        </S.CardContent>
      </S.SummaryCard>
    </S.SummaryCardsContainer>
  );
};

export default SummaryCards;
